import { render } from "./MyClub.vue?vue&type=template&id=c0f1787c&scoped=true"
import script from "./MyClub.vue?vue&type=script&lang=js"
export * from "./MyClub.vue?vue&type=script&lang=js"

import "./MyClub.vue?vue&type=style&index=0&id=c0f1787c&scoped=true&lang=css"

import exportComponent from "/Users/andreaskura/repos/cio-online-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0f1787c"]])

export default __exports__